// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `pnpm build-icons` instead of editing. */ import { ReactComponent as ChevronRightDefault } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/default/arrows/chevron-right.svg?react';
import { ReactComponent as ChevronRightSolid } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/solid/arrows/chevron-right.svg?react';
import { createIcons } from '../../Icon';
export const ChevronRightIcon = /* @__PURE__ */ createIcons('ChevronRight', {
    default: ChevronRightDefault,
    solid: ChevronRightSolid
});
ChevronRightIcon.supportedTypes = [
    'default',
    'solid'
];
